module.exports = __webpack_public_path__ + "static/Projekt pomnika Wojciecha Bogusławskiego NAC-c53c4b4ad31edb3c381ef38379217a99.jpg";